module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("b3aBS"))).then(() => parcelRequire('1iHdE'));